import gql from 'graphql-tag'

export const LIST = gql`
  query order($filter: OrderFilter, $sort: SortDirection, $offset: Int, $limit: Int ) {
    order(filter: $filter, sort: $sort, offset: $offset, limit: $limit) {
      data {
        id title status_code status_name contract_id company_id company_name user_id counteragent_company_id counteragent_company_name counteragent_user_id number delivery_address subsidiary_id reject_reason start_at direction delivery_at
      }
      total_count
    }
  }
`

export const CREATE = gql`
  mutation create_order($contract_id: Int, $counteragent_id: Int) {
    create_order(contract_id: $contract_id, counteragent_id: $counteragent_id) {
      id title status_code contract_id company_id user_id counteragent_company_id counteragent_user_id
      number delivery_address subsidiary_id reject_reason start_at delivery_at
    }
  }
`

export const STATE = gql`
  query order_state($id: Int!) {
    order_state(id: $id) {
      type : __typename
      ... on IntegerField { spec { title name editable reference required causer } value possible_values errors }
      ... on StringField { spec { title name editable reference required causer } value possible_values errors }
      ... on DatetimeField { spec { title name editable reference required causer } value possible_values errors }
      ... on BooleanField { spec { title name editable reference causer } value possible_values errors }
      ... on FloatField { spec { title name editable reference required causer } value possible_values errors }
      ... on DecimalField { spec { title name editable reference required causer } value possible_values errors }
    }
  }
`

export const UPDATE_STATE = gql`
  mutation update_order_state($id: Int!, $field: Json!) {
    update_order_state(id: $id, field: $field) {
      type : __typename
      ... on IntegerField { spec { title name editable reference required causer } value possible_values errors }
      ... on StringField { spec { title name editable reference required causer } value possible_values errors }
      ... on DatetimeField { spec { title name editable reference required causer } value possible_values errors }
      ... on BooleanField { spec { title name editable reference required causer } value possible_values errors }
      ... on FloatField { spec { title name editable reference required causer } value possible_values errors }
      ... on DecimalField { spec { title name editable reference required causer } value possible_values errors }
    }
  }
`

export const STATUSES = gql`
  query order_status {
    order_status {
      id code title order action
    }
  }
`

export const STATS = gql`
  query order_stats($filter: OrderFilter) {
    order_stats(filter: $filter) {
      group count
    }
  }
`

export const LOGS = gql`
  query order_logs($filter: OrderLogFilter, $sort: SortDirection, $offset: Int, $limit: Int) {
    order_logs(filter: $filter, sort: $sort, offset: $offset, limit: $limit) {
      items {
        orderId orderOwnerId orderTitle companyId companyTitle userId userName prevStatus newStatus insertedAt
      }
      total_count
    }
  }
`

export const LOGS_STATS = gql`
  query order_logs_stats($filter: OrderLogFilter) {
    order_logs_stats(filter: $filter) {
      group count
    }
  }
`

export const POSITIONS = gql`
  query order_position($filter: OrderPositionFilter, $offset: Int, $limit: Int) {
    order_position(filter: $filter, offset: $offset, limit: $limit) {
      positions { id position_id title anno amount contract_amount unit_id price vat currency_id delivery_within_days vendor_code }
      totalCount
      actions { create read update delete }
    }
  }
`

export const APPEND_CONTRACT_POSITIONS = gql`
  mutation append_contract_positions($order_id: Int!, $contract_id: Int!) {
    append_contract_positions(order_id: $order_id, contract_id: $contract_id) {
      positions { id position_id title anno amount contract_amount unit_id price vat currency_id delivery_within_days vendor_code }
      errors { field, errors }
    }
  }
`

export const REMOVE_POSITIONS = gql`
  mutation remove_order_positions($order_id: Int!) {
    remove_order_positions(order_id: $order_id) {
      removed
    }
  }
`

export const CREATE_POSITION = gql`
  mutation create_order_position($order_id: Int!, $input: OrderPositionInput!) {
    create_order_position(order_id: $order_id, input: $input) {
      position { id position_id title anno amount contract_amount unit_id price vat currency_id delivery_within_days vendor_code }
      errors { field, errors }
    }
  }
`

export const UPDATE_POSITION = gql`
  mutation update_order_position($position_id: Int!, $input: OrderPositionInput!) {
    update_order_position(position_id: $position_id, input: $input) {
      position { id position_id title anno amount contract_amount unit_id price vat currency_id delivery_within_days vendor_code }
      errors { field, errors }
    }
  }
`

export const DELETE_POSITION = gql`
  mutation delete_order_position($id: Int!) {
    delete_order_position(id: $id) {
      position { id position_id title anno amount contract_amount unit_id price vat currency_id delivery_within_days vendor_code }
      errors { field, errors }
    }
  }
`
